var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('s-tabs',{on:{"change":_vm.handleTabsChange}}),(_vm.allTabs.length > 0)?_c('s-doc',{attrs:{"id":_vm.currentTabId}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }